module.exports = __webpack_public_path__ + "img/more.b9bf59f4.svg";